/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


/** @import Global Interface Data State Type */
import INTERFACE_STATE_TYPE from "@Actions/Interface";

/** @import Global Api Request Status Action, Global Interface Data Action Type */
import {
    CHANGE_API_REQUEST_STATUS, // Global Api Request Status Action
    CHANGE_MODAL_MESSAGE,
    INTERFACE_ACTION_TYPE // Global Interface Data Action Type
} from "@Actions/Interface";


/** @interface InterfaceState Global Interface Data Default State */
const InterfaceState = {
    apiRequestStatus: false, // Global Api Request Status
    modalMessage: null
};


export const InterfaceReducer = (
    state: INTERFACE_STATE_TYPE = InterfaceState,
    action: INTERFACE_ACTION_TYPE
): INTERFACE_STATE_TYPE => {

    switch (action.type) {

        case CHANGE_API_REQUEST_STATUS:
            return {...state, apiRequestStatus: action.status || false};

        case CHANGE_MODAL_MESSAGE:
            return {...state, modalMessage: action?.message?.content ? action.message : null};

        default:
            return state;

    }

};


export default InterfaceReducer;
